import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-therena',
  templateUrl: './therena.component.html',
  styleUrls: ['./therena.component.css']
})
export class TherenaComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
